import React, { useLayoutEffect, useRef } from 'react';

const FreeIframe = (props) => {

    const {
        css,
        preIframe = '',
        urlIframe = '',
        postIframe = '',
        border,
        divId,
        width = '100%',
        height = '280px',
    } = props;

    const containerRef = useRef();

    useLayoutEffect(() => {
        let iframe = document.createElement("iframe");
        iframe.src = urlIframe;
        iframe.width = width;
        iframe.height = height;
        iframe.frameBorder = border ? 0 : 1;
        containerRef.current.innerHTML = '';
        containerRef.current.appendChild(iframe);
    }, [])
    
    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: css }}></style>
            <div id={divId}>
                <div dangerouslySetInnerHTML={{ __html: preIframe }}></div>
                <div ref={containerRef}>
                </div>
                <div dangerouslySetInnerHTML={{ __html: postIframe }}></div>
            </div>
        </>
    )
}

export default FreeIframe;